import { create } from "zustand";

import { STRINGS } from "../utils/strings";

const initialState = {
  data: [],
  loading: false,
  currentPage: STRINGS.DEFAULT_PAGE,
  resLimit: STRINGS.DEFAULT_PAGINATION_LIMIT,
  resultCount: 0,
  searchText: "",
  selectedSummaryNote: null,
  chipData: [],
  showRightTopBar: false,
  disableCopyButton: false,
  selectedCase: null,
  navigationCaseId: null,
  readNotes: null,
  selectedSummaryNoteContent: null,
  summaryNoteLoading: false,
};

export const useAISummaryStore = create((set) => ({
  ...initialState,

  setData: (data) => set({ data }),
  setLoading: (loading) => set({ loading }),
  setCurrentPage: (page) => set({ currentPage: page }),
  setResLimit: (limit) => set({ resLimit: limit }),
  setResultCount: (count) => set({ resultCount: count }),
  setSearchText: (value) => set({ searchText: value }),
  setSelectedSummaryNote: (value) => set({ selectedSummaryNote: value }),
  setChipData: (value) => set({ chipData: value }),
  setShowRightTopBar: (value) => set({ showRightTopBar: value }),
  setDisableCopyButton: (value) => set({ disableCopyButton: value }),
  setSelectedCase: (value) => set({ selectedCase: value }),
  setNavigationCaseId: (value) => set({ navigationCaseId: value }),
  setReadNotes: (value) => set({ readNotes: value }),
  setSelectedSummaryNoteContent: (value) => set({ selectedSummaryNoteContent: value }),
  setSummaryNoteLoading: (value) => set({ summaryNoteLoading: value }),

  resetCurrentPage: () => set({ currentPage: 1 }),
  resetRightPanel: () =>
    set({
      selectedSummaryNote: null,
      showRightTopBar: false,
      disableCopyButton: false,
      selectedCase: null,
      navigationCaseId: null,
      selectedSummaryNoteContent: null,
    }),
  reset: () => set(initialState),
}));
